import {createFileRoute} from '@tanstack/react-router';
import {KnowYourCustomerPageV4} from 'pages/kyc/KnowYourCustomerPageV4';

export const Route = createFileRoute('/_protected/kyc/$id')({
  component: KnowYourCustomerPageV4,
  validateSearch: (params: {mode?: string}) => {
    const mode = `${params.mode}`;
    return {
      mode: ['self-initiated', 'mandatory'].includes(mode) ? mode : 'mandatory',
    };
  },
});
